module.exports = __webpack_public_path__ + "static/media/t2.fce685ef.jpg";